<template>
  <div class="status-badge" :class="statusClass">
    {{ statusText }}
  </div>
</template>

<script>
export default {
  name: 'StatusBadge',
  props: {
    status: {
      type: String,
      required: true,
      validator: (value) =>
        ['queued', 'processing', 'completed', 'failed'].includes(value),
    },
  },
  computed: {
    statusClass() {
      const statusMap = {
        queued: 'status-queued',
        processing: 'status-processing',
        completed: 'status-completed',
        failed: 'status-failed',
      };
      return statusMap[this.status] || 'status-queued';
    },
    statusText() {
      const textMap = {
        queued: 'In Coda',
        processing: 'In Elaborazione',
        completed: 'Completata',
        failed: 'Fallita',
      };
      return textMap[this.status] || 'Sconosciuto';
    },
  },
};
</script>

<style scoped>
.status-badge {
  display: inline-block;
  padding: 0.5rem 1rem;
  border: 2px solid;
  font-weight: 500;
  font-size: 0.875rem;
  text-align: center;
  white-space: nowrap;
}

/* Queued - Gray */
.status-queued {
  background-color: #f3f4f6;
  border-color: #9ca3af;
  color: #374151;
}

/* Processing - Yellow/Orange */
.status-processing {
  background-color: #fef3c7;
  border-color: #f59e0b;
  color: #92400e;
}

/* Completed - Green */
.status-completed {
  background-color: #d1fae5;
  border-color: #10b981;
  color: #065f46;
}

/* Failed - Red */
.status-failed {
  background-color: #fee2e2;
  border-color: #ef4444;
  color: #991b1b;
}

@media (max-width: 768px) {
  .status-badge {
    font-size: 0.75rem;
    padding: 0.375rem 0.75rem;
  }
}
</style>
